import React from "react";
import { useQuery, useQueries } from 'react-query'
import { getResultsRSC, getUnits, getResultsPhase } from "data/Querys"
import Loader from 'components/general/Loader'
import NotAvailable from "components/common/NotAvailable";
import PageHeader from "components/common/PageHeader";
import ProgressionRule from 'components/common/ProgressionRule'
import PhotoFinish from "components/general/PhotoFinish";
import BmxResults from "components/sports/bmx/views/BmxResults";
import BmxSummary from "components/sports/bmx/views/BmxSummary";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getPhaseRSC, getLongPhaseRSC } from 'helpers/rsc'

const SjpContext = () => {
    const { mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    let QFNL = mirs_rsc.includes('QFNL')
    let SFNL = mirs_rsc.includes('SFNL')
    let REP = mirs_rsc.includes('REP')
    let FNL = mirs_rsc.includes('-FNL-')
    const _longPhase = getLongPhaseRSC(mirs_rsc);

    const _phase = getPhaseRSC(mirs_rsc);

        //GET units in phase
        const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
            {
                queryKey: ['unitsPhase', mirs_competition, mirs_language, _phase],
                queryFn: getUnits,
                //refetchInterval: 30000,
                staleTime: Infinity,
                refetchIntervalInBackground: true,
                notifyOnChangeProps: ['data', 'error'],
            }
        );

        let queryArray = [];

        //GET results
        unitsData?.phase?.units?.forEach((unit) => {
            queryArray.push({
                queryKey: ['resultsData', mirs_competition, unit.code, mirs_language, _longPhase, undefined, undefined, (QFNL || SFNL) ? unit.code : _longPhase],
                queryFn: getResultsRSC,
                refetchInterval: 5000,
                staleTime: 5000,
                refetchIntervalInBackground: true,
                notifyOnChangeProps: ['data', 'error'],
            })
        });

        const { data: phaseResult, isError: phaseResultError, isLoading: phaseResultLoading } = useQuery(
            {
                queryKey: ['resultsPhaseSummary', mirs_competition, getPhaseRSC(mirs_rsc), mirs_language],
                queryFn: getResultsPhase,
                refetchInterval: 5000,
                staleTime: 5000,
                refetchIntervalInBackground: true,
                notifyOnChangeProps: ['data', 'error'],
            });    
    
    const resultsData = useQueries(queryArray);
    const isLoading = unitsLoading || resultsData.some(result => result.isLoading) || phaseResultLoading
    const isError = unitsError || resultsData.some(result => result.isError) || phaseResultError
    const results = resultsData.filter(res => res?.data?.results)

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }
    if (!results || !Array.isArray(results) || results.length == 0) { return <NotAvailable />}

    if(QFNL || SFNL){
        results?.forEach(run => 
            {
                run?.data?.results?.items?.forEach(item => 
                {
                    let summaryResults = phaseResult?.phaseResults[0]?.items?.find( i => i?.athleteCode === item?.participant?.code)
                    item.summaryResults = summaryResults
                });
            });
    }

    let run1 = []
    let run2 = []
    let run3 = []
        results?.map((res) => {
            if (res?.data?.results !== undefined){
                if (res?.data?.results?.eventUnitCode.includes('10'))
                    run1.push(res)
                else if (res?.data?.results?.eventUnitCode.includes('20'))
                    run2.push(res)
                else if (res?.data?.results?.eventUnitCode.includes('30'))
                    run3.push(res)
            }
        })

    return (
        <>
            {QFNL || SFNL
                ? <PageHeader data={results[0]?.data} title={results[0]?.data?.results?.eventUnit?.shortDescription.slice(0,-8)}/>
                : <PageHeader data={results[0]?.data} title={results[0]?.data?.results?.eventUnit?.shortDescription}/>
            }
            <ProgressionRule
                key="progress-component"
                data={results[0]?.data?.config}
                filter={{ type: ['QUALIFICATION'], code: ['QUAL_RULE'] }}
            />
            {QFNL || SFNL
                ?
                <>
                <Tabs id="mirs-navsport" className="mb-3 mirs-tab-result">
                    <Tab eventKey={`1-${mirs_rsc}`} title={<Label data={'HeaderRun1'} />}>
                        {run1.map((res1, index) => {
                            if (res1.data?.images !== undefined && res1.data?.results?.items !== undefined && res1?.data?.results?.status?.code === 'OFFICIAL')
                            {
                                return (
                                <>
                                    <PhotoFinish key={`photofinish-component-${index}`} data={res1?.data?.images} />
                                    <BmxResults key={`results-component-${index}`} data={res1.data} />
                                </>
                                )
                            }
                            else if (res1.data?.results?.items !== undefined)
                                return <BmxResults key={`results-component-${index}`} data={res1.data} />
                        })
                        }
                    </Tab>
                    <Tab eventKey={`2-${mirs_rsc}`} title={<Label data={'HeaderRun2'} />}>
                        {run2.map((res2, index) => {
                            if (res2.data?.images !== undefined && res2.data?.results?.items !== undefined && res2?.data?.results?.status?.code === 'OFFICIAL')
                            {
                                return (
                                <>
                                    <PhotoFinish key={`photofinish-component-${index}`} data={res2?.data?.images} />
                                    <BmxResults key={`results-component-${index}`} data={res2.data} />
                                </>
                                )
                            }
                            else if (res2.data?.results?.items !== undefined)
                                return <BmxResults key={`results-component-${index}`} data={res2.data} />
                        })
                        }
                    </Tab>
                    <Tab eventKey={`3-${mirs_rsc}`} title={<Label data={'HeaderRun3'} />}>
                        {run3.map((res3, index) => {
                            if (res3.data?.images !== undefined && res3.data?.results?.items !== undefined && res3?.data?.results?.status?.code === 'OFFICIAL')
                            {
                                return (
                                <>
                                    <PhotoFinish key={`photofinish-component-${index}`} data={res3?.data?.images} />
                                    <BmxResults key={`results-component-${index}`} data={res3?.data} />
                                </>
                                )
                             }
                            else if (res3.data?.results?.items !== undefined)
                                return <BmxResults key={`results-component-${index}`} data={res3.data} />
                        })
                        }
                    </Tab>
                    <Tab eventKey={`4-${mirs_rsc}`} title={<Label data={'LabelSummary'} />}>
                        {phaseResult && 
                            <BmxSummary data={phaseResult?.phaseResults[0]}/>
                        }
                    </Tab>
                </Tabs>
                </>
                : (REP || FNL) && results[0]?.data?.images !== undefined && results[0]?.data?.results?.status?.code === 'OFFICIAL'
                    ?
                    <>
                        <PhotoFinish key={`photofinish-component`} data={results[0]?.data?.images} />
                        <BmxResults data={results[0]?.data} />
                    </>
                    : <BmxResults data={results[0]?.data} />
            }
        </>
    )

}

export default SjpContext;